module.exports = __webpack_public_path__ + "img/email.6d5a67a0.svg";